import { Box } from '@mantine/core';

import Viewer from '../../../components/SmartForm/Viewer';
import { useAppSelector } from '../../../store/hooks';

export default function Info() {
  const current = useAppSelector(state => state.lote.current);

  if (!current || !current.fieldItemGroups) return null;

  return (
    <Box>
      <Viewer
        type="tabs"
        entityId={current.id}
        fieldItemGroups={current.fieldItemGroups}
        onActionRender={() => null}
      />
    </Box>
  );
}
